"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.fetchNamespace = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _fetchWithCache = _interopRequireDefault(require("./utils/fetchWithCache"));
var _gatsby = require("gatsby");
var fetchNamespace = exports.fetchNamespace = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(intl, ns) {
    var language, _intl$localeJsonSourc, localeJsonSourceName, nsPath, raw, json;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          language = intl.language, _intl$localeJsonSourc = intl.localeJsonSourceName, localeJsonSourceName = _intl$localeJsonSourc === void 0 ? "locales" : _intl$localeJsonSourc;
          nsPath = (0, _gatsby.withAssetPrefix)("/" + localeJsonSourceName + "/" + language + "/" + ns + ".json");
          _context.next = 5;
          return (0, _fetchWithCache.default)(nsPath);
        case 5:
          raw = _context.sent;
          json = raw;
          return _context.abrupt("return", json);
        case 10:
          _context.prev = 10;
          _context.t0 = _context["catch"](0);
          return _context.abrupt("return", {});
        case 13:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 10]]);
  }));
  return function fetchNamespace(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();